import { Home, Building, Crown, Sparkles } from 'lucide-react'

interface Category {
  id: string
  name: string
  icon: React.ReactNode
}

interface CategoryNavProps {
  categories: Category[]
  selectedCategory: string
  loading: boolean
  onCategoryChange: (categoryId: string) => void
}

const CategoryNav = ({ categories, selectedCategory, loading, onCategoryChange }: CategoryNavProps) => {
  return (
    <div className="bg-white rounded-xl shadow-sm p-3 sm:p-4 overflow-x-auto">
      <div className="flex gap-2 min-w-max sm:flex-wrap">
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => onCategoryChange(category.id)}
            disabled={loading}
            className={`flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap ${
              selectedCategory === category.id
                ? 'bg-primary-500 text-white shadow-md'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            {category.icon}
            <span>{category.name}</span>
          </button>
        ))}
      </div>
    </div>
  )
}

export default CategoryNav

